module.exports = __webpack_public_path__ + "static/media/premium_v2.59bc2e4d.png";